import CreateModelModal from './CreateModelModal';

import './CreateModelModal.scss';

export default CreateModelModal;
